(function () {
  'use strict';

  /* Apparition au scroll (léger) */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(reveals, function (el) { io.observe(el); });
  } else {
    Array.prototype.forEach.call(reveals, function (el) { el.classList.add('is-in'); });
  }

  /* Slider d'avis : défilement à accroche, flèches, clavier */
  Array.prototype.forEach.call(document.querySelectorAll('[data-slider]'), function (s) {
    var tr = s.querySelector('[data-slider-track]'), prev = s.querySelector('[data-slider-prev]'), next = s.querySelector('[data-slider-next]');
    if (!tr || !prev || !next) return;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function cardW() { var c = tr.querySelector('.review'); return c ? c.getBoundingClientRect().width + 20 : tr.clientWidth * 0.8; }
    function page() { var w = cardW(); return Math.max(1, Math.round(tr.clientWidth / w)) * w; }
    function upd() {
      prev.disabled = tr.scrollLeft <= 2;
      next.disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 2;
      var nav = s.querySelector('[data-slider-nav]');
      if (nav) nav.hidden = tr.scrollWidth <= tr.clientWidth + 2;
    }
    prev.addEventListener('click', function () { tr.scrollBy({ left: -page(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { tr.scrollBy({ left: page(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    var tk; tr.addEventListener('scroll', function () { clearTimeout(tk); tk = setTimeout(upd, 60); }, { passive: true });
    tr.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); next.click(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); prev.click(); }
    });
    window.addEventListener('resize', upd);
    upd();
  });

  /* Visionneuse : agrandir une photo (avis, galerie produit) */
  var lbEl = null, lbItems = [], lbIndex = 0, lbFrom = null, lbTouch = 0;
  function lbShow(i) {
    lbIndex = (i + lbItems.length) % lbItems.length;
    lbEl.querySelector('.lb__img').src = lbItems[lbIndex].getAttribute('data-zoom');
    var multi = lbItems.length > 1;
    lbEl.querySelector('.lb__prev').hidden = !multi;
    lbEl.querySelector('.lb__next').hidden = !multi;
    lbEl.querySelector('.lb__count').textContent = multi ? (lbIndex + 1) + ' / ' + lbItems.length : '';
  }
  function lbClose() {
    if (!lbEl) return;
    document.body.removeChild(lbEl); lbEl = null;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', lbKey);
    if (lbFrom && lbFrom.focus) lbFrom.focus();
  }
  function lbKey(e) {
    if (e.key === 'Escape') lbClose();
    else if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
    else if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
  }
  function lbOpen(el) {
    var g = el.getAttribute('data-zoom-group');
    lbItems = g ? Array.prototype.slice.call(document.querySelectorAll('[data-zoom-group="' + g + '"]')) : [el];
    lbFrom = el;
    lbEl = document.createElement('div');
    lbEl.className = 'lb'; lbEl.setAttribute('role', 'dialog'); lbEl.setAttribute('aria-modal', 'true'); lbEl.setAttribute('aria-label', 'Photo agrandie');
    lbEl.innerHTML = '<button type="button" class="lb__close" aria-label="Fermer">×</button>' +
      '<button type="button" class="lb__nav lb__prev" aria-label="Photo précédente">‹</button>' +
      '<img class="lb__img" alt="">' +
      '<button type="button" class="lb__nav lb__next" aria-label="Photo suivante">›</button>' +
      '<span class="lb__count"></span>';
    document.body.appendChild(lbEl);
    document.body.style.overflow = 'hidden';
    lbShow(lbItems.indexOf(el));
    lbEl.querySelector('.lb__close').focus();
    document.addEventListener('keydown', lbKey);
    lbEl.addEventListener('click', function (e) {
      if (e.target.closest('.lb__close') || e.target === lbEl) lbClose();
      else if (e.target.closest('.lb__prev')) lbShow(lbIndex - 1);
      else if (e.target.closest('.lb__next')) lbShow(lbIndex + 1);
    });
    lbEl.addEventListener('touchstart', function (e) { lbTouch = e.changedTouches[0].clientX; }, { passive: true });
    lbEl.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - lbTouch;
      if (Math.abs(dx) > 50 && lbItems.length > 1) lbShow(lbIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }
  document.addEventListener('click', function (e) {
    var z = e.target.closest('[data-zoom]');
    if (z && !lbEl) { e.preventDefault(); lbOpen(z); }
  });

  /* Filtres de collection : envoi automatique, panneau replié sur mobile */
  var fform = document.querySelector('[data-filters-form]');
  if (fform) {
    var fbox = document.querySelector('[data-filters-box]');
    if (fbox) fbox.open = window.innerWidth > 820;
    var ft;
    fform.addEventListener('change', function () { clearTimeout(ft); ft = setTimeout(function () { fform.submit(); }, 250); });
  }

  /* Menu mobile */
  var burger = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-menu]');
  if (burger && menu) {
    burger.addEventListener('click', function () { menu.classList.toggle('is-open'); });
  }

  /* Tri des collections */
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* Boutons de quantité (fiche produit et panier) */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var input = (minus || plus).parentNode.querySelector('input');
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var value = parseInt(input.value || '0', 10) + (plus ? 1 : -1);
    input.value = Math.max(min, value);
    if (input.hasAttribute('data-cart-qty')) {
      var update = document.querySelector('[data-cart-update]');
      if (update) update.click();
    }
  });

  var cartQty = document.querySelectorAll('[data-cart-qty]');
  Array.prototype.forEach.call(cartQty, function (input) {
    input.addEventListener('change', function () {
      var update = document.querySelector('[data-cart-update]');
      if (update) update.click();
    });
  });

  /* Fiche produit : variantes, prix, Klarna, images */
  var section = document.querySelector('[data-product-section]');
  var dataEl = document.getElementById('product-variants');
  if (!section || !dataEl) return;

  var variants = JSON.parse(dataEl.textContent);
  var form = document.getElementById('product-form');
  var idInput = section.querySelector('[data-variant-id]');
  var priceEl = section.querySelector('[data-price]');
  var compareEl = section.querySelector('[data-compare]');
  var klarnaEl = section.querySelector('[data-klarna-amount]');
  var addBtn = section.querySelector('[data-add]');
  var addLabel = section.querySelector('[data-add-label]');

  function selectedOptions() {
    var fields = section.querySelectorAll('.opt');
    return Array.prototype.map.call(fields, function (f) {
      var checked = f.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  function showMedia(id) {
    if (!id) return;
    var slides = section.querySelectorAll('.pdp__slide');
    var found = false;
    Array.prototype.forEach.call(slides, function (s) {
      var on = s.getAttribute('data-media-id') === String(id);
      if (on) found = true;
    });
    if (!found) return;
    Array.prototype.forEach.call(slides, function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(id));
    });
    var thumbs = section.querySelectorAll('[data-thumb]');
    Array.prototype.forEach.call(thumbs, function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id));
    });
  }

  function update() {
    var chosen = selectedOptions();
    var match = variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    })[0];

    if (!match) {
      addBtn.disabled = true;
      addLabel.textContent = 'Indisponible';
      return;
    }

    idInput.value = match.id;
    priceEl.textContent = match.price;
    if (compareEl) {
      compareEl.textContent = match.compare;
      compareEl.hidden = !match.hasCompare;
    }
    if (klarnaEl) klarnaEl.textContent = match.klarna;
    var saveEl = section.querySelector('[data-save]'), badgeEl = section.querySelector('[data-badge]');
    var stockEl = section.querySelector('[data-stock]');
    if (saveEl) { saveEl.textContent = 'Économisez ' + match.save; saveEl.hidden = !match.hasCompare; }
    if (badgeEl) { badgeEl.textContent = '-' + match.pct + '%'; badgeEl.hidden = !match.hasCompare; }
    if (stockEl) { stockEl.textContent = match.stock; stockEl.classList.toggle('pdp__stock--out', !match.available); }

    addBtn.disabled = !match.available;
    addLabel.textContent = match.available ? 'Ajouter au panier' : 'Épuisé';
    showMedia(match.media);

    var url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url.toString());
  }

  section.addEventListener('change', function (e) {
    if (e.target.closest('.opt')) update();
  });

  section.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) showMedia(thumb.getAttribute('data-thumb'));
  });

  if (!section.querySelector('.pdp__slide.is-active')) {
    var first = section.querySelector('.pdp__slide');
    if (first) first.classList.add('is-active');
  }
})();
